import { createContext } from "react";
import type IUserContext from "../types/IToastContext";
import type NotificationType from "../types/NotificationType";

const UserContext = createContext<IUserContext>({
  values: {
    notifications: [],
  },
  actions: {
    addNotification: (type: NotificationType, content: string) => undefined,
    removeNotificationById: (id: string) => undefined,
  },
});

export default UserContext;
